import { RudderAnalytics } from '@rudderstack/analytics-js';
import { guestbookSites, environment } from '../settings/IntegrationConstants';

const rudderAnalytics = new RudderAnalytics();

const apiKey = guestbookSites[environment]?.rudderstack?.api_key;
if (!apiKey) {
  console.error('Rudderstack API key missing for environment:', environment);
} else {
  rudderAnalytics.load(apiKey, 'https://theguestbovybg.dataplane.rudderstack.com');
}

const safeRudderAnalytics = new Proxy(rudderAnalytics, {
  get(target, prop) {
    if (typeof target[prop] === 'function') {
      return (...args) => {
        try {
          console.log(`Intercepted call to: ${prop}`, { args });
          return target[prop](...args);
        } catch (err) {
          console.error(`RudderAnalytics error calling ${prop}:`, err);
        }
      };
    } else {
      return target[prop];
    }
  },
});

export default safeRudderAnalytics;
